<template>
  <div class="mb-4 border-bottom border-top pt-3 pb-1">
    <h5>{{ $t("family.market.box.marketEvents") }}</h5>

    <div class="d-flex justify-content-center flex-column" v-if="loading">
      <div class="w-100 m-0">
        <Skeleton width="100%" height="25px" />
      </div>
      <div class="w-100 m-0">
        <Skeleton width="100%" height="25px" />
      </div>
    </div>
    <div v-else class="d-flex flex-column">
      <div
        class="mb-1 w-100 p-2 rounded bg-gray-100"
        v-for="(data, index) in datasetFiltered"
        :key="index"
        :v-html="data.title"
      >
        <span v-html="data.title"></span>
      </div>

      <div>
        <div class="w-100 pl-2 pt-2 mb-3">
          <router-link
            :to="{
              name: 'RoleOrdersManage',
              params: { id: roleId },
              query: { view: 'ddmp' },
            }"
            >{{
              $t("family.dashboard.products.producerviewproducts")
            }}
            →</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Skeleton from "../../common/table/Skeleton.vue";
import { apiGetDirectUrl } from "../../helpers/apiHelper";

function addDays(days) {
  var result = new Date();
  result.setDate(result.getDate() + days);
  return result;
}

export default {
  components: {
    Skeleton,
  },

  data() {
    return {
      loading: false,
      dataset: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    // whenever question changes, this function will run
    roleId(newRoleId, oldRoleId) {
      if (newRoleId != oldRoleId) {
        this.getData();
      }
    },
  },
  methods: {
    async getData() {
      const self = this;
      this.loading = true;
      let date_start, date_end;
      date_start = addDays(0);
      date_end = addDays(+60);
      const roleId = this.roleId;

      const response = await apiGetDirectUrl(
        `/api/role/${roleId}/planning/calendar/${date_start.valueOf()}/${date_end.valueOf()}/`
      );

      if (response && response.data && response.status === 200) {
        console.log("Fetched calendar data:", response.data);
        self.loading = false;
        self.dataset = response.data.payload;
      } else {
        self.loading = false;
      }
    },
  },
  computed: {
    roleId() {
      return this.$store.state.role.id;
    },
    datasetFiltered() {
      let list_dates = [];
      const i18n = this.$i18n;
      this.dataset.forEach(function (data, index) {
        // console.log(data, index);
        if (data.e_type == "P") {
          list_dates.push({
            title:
              "<b>" +
              moment(data.startDate).locale(i18n.locale).format("L") +
              "</b> " +
              data.title +
              " " +
              i18n.t("role.dashboard.producer.timeAt") +
              " " +
              moment(data.startDate).locale(i18n.locale).format("LT"),
            startDate: data.startDate,
            class: "primary",
          });
        } else if (data.e_type == "C") {
          list_dates.push({
            title:
              "<b>" +
              moment(data.startDate).locale(i18n.locale).format("L") +
              "</b> " +
              data.title +
              " " +
              i18n.t("role.dashboard.producer.finishedAt") +
              " + " +
              moment(data.endDate).locale(i18n.locale).format("L"),
            startDate: data.startDate,
            class: "danger",
          });
        }
      });
      return list_dates.sort((a, b) => a.startDate - b.startDate).slice(0, 5);
    },
  },
};
</script>
